export default __webpack_public_path__ + "fonts/poppins-latin-300-normal.5558b04900a67eaa589e.woff";